// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-radio-group {
  width: 100%;
  border-radius: 5px;
  padding: 5px;
  display: block;
}
ion-radio-group ion-item {
  background: #ffffff;
  border-bottom: var(--outline-default);
}
ion-radio-group ion-item:first-child {
  border-top: var(--outline-default);
}

.price {
  font-size: 14px;
  color: var(--ion-color-black);
  font-weight: 400;
  text-align: end;
}

ion-label {
  font-size: 14px;
  text-transform: uppercase;
}

ion-icon {
  color: var(--ion-color-primary);
  height: 20px;
  width: 20px;
}

app-tag {
  display: inline-block;
}

.pfand {
  font-size: 10px;
}

ion-checkbox {
  --background: transparent;
  --background-checked: var(--ion-color-primary);
  --border-color: var(--ion-color-primary-shade);
  --border-color-checked: var(--ion-color-primary);
  --border-width: 1px;
  --checkmark-color: var(--color-white);
  --checkmark-width: 2px;
  --border-radius: var(--radius-default);
  --checkbox-background: transparent;
  --size: 20px;
}

app-tag {
  display: inline-flex;
}`, "",{"version":3,"sources":["webpack://./src/app/components/article-option-group-checkbox/article-option-group-checkbox.component.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;AACD;AACC;EACC,mBAAA;EAEA,qCAAA;AAAF;AAEE;EACC,kCAAA;AAAH;;AAKA;EACC,eAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;AAFD;;AAKA;EACC,eAAA;EACA,yBAAA;AAFD;;AAKA;EACC,+BAAA;EACA,YAAA;EACA,WAAA;AAFD;;AAKA;EACC,qBAAA;AAFD;;AAKA;EACC,eAAA;AAFD;;AAKA;EACC,yBAAA;EACA,8CAAA;EACA,8CAAA;EACA,gDAAA;EACA,mBAAA;EACA,qCAAA;EACA,sBAAA;EACA,sCAAA;EACA,kCAAA;EACA,YAAA;AAFD;;AAKA;EACC,oBAAA;AAFD","sourcesContent":["ion-radio-group {\n\twidth: 100%;\n\tborder-radius: 5px;\n\tpadding: 5px;\n\tdisplay: block;\n\n\tion-item {\n\t\tbackground: #ffffff;\n\t\t// border-radius: var(--radius-default);\n\t\tborder-bottom: var(--outline-default);\n\n\t\t&:first-child {\n\t\t\tborder-top: var(--outline-default);\n\t\t}\n\t}\n}\n\n.price {\n\tfont-size: 14px;\n\tcolor: var(--ion-color-black);\n\tfont-weight: 400;\n\ttext-align: end;\n}\n\nion-label {\n\tfont-size: 14px;\n\ttext-transform: uppercase;\n}\n\nion-icon {\n\tcolor: var(--ion-color-primary);\n\theight: 20px;\n\twidth: 20px;\n}\n\napp-tag {\n\tdisplay: inline-block;\n}\n\n.pfand {\n\tfont-size: 10px;\n}\n\nion-checkbox {\n\t--background: transparent;\n\t--background-checked: var(--ion-color-primary);\n\t--border-color: var(--ion-color-primary-shade);\n\t--border-color-checked: var(--ion-color-primary);\n\t--border-width: 1px;\n\t--checkmark-color: var(--color-white);\n\t--checkmark-width: 2px;\n\t--border-radius: var(--radius-default);\n\t--checkbox-background: transparent;\n\t--size: 20px;\n}\n\napp-tag {\n\tdisplay: inline-flex;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
